module.exports = __webpack_public_path__ + "media/images/tuscany-01c8a43a00426176706a3fbda79c6351.svg";